export default {
  close: 'Close',
  dataIterator: {
    pageText: '{0}-{1} Dritter/{2}',
    noResultsText: 'Suchergebnis nicht gefunden.',
    loadingText: 'Loading item...',
  },
  dataTable: {
    itemsPerPageText: 'Zeilen pro Seite:',
    ariaLabel: {
      sortDescending: ': Sorted descending. Activate to remove sorting.',
      sortAscending: ': Sorted ascending. Activate to sort descending.',
      sortNone: ': Not sorted. Activate to sort ascending.',
    },
    sortBy: 'Sort by',
  },
  dataFooter: {
    itemsPerPageText: 'Anzahl der Artikel pro Seite:',
    itemsPerPageAll: 'Alle',
    nextPage: 'Nächste Seite',
    prevPage: 'Vorherige Seite',
    firstPage: 'Erste Seite',
    lastPage: 'Letzte Seite',
  },
  datePicker: {
    itemsSelected: '{0} Datumsauswahl',
  },
  noDataText: 'Keine Daten verfügbar.',
  carousel: {
    prev: 'Vorherige Visualisierung',
    next: 'Folgende Visualisierungen',
  },
  calendar: {
    moreEvents: 'Mehr {0}',
  },
  fileInput: {
    counter: '{0} Files',
    counterSize: '{0} Files ({1} in total)',
  },
  observation: {
    accumulatedTemperature: 'Effektive integrierte Temperatur',
    accumulatedTemperatureList: 'Effektive kumulierte Temperaturliste',
    startDateCalculation: 'Datum des Beginns der Berechnung',
    endDateCalculation: 'Enddatum der Akkumulation',
    lowerLimitTemperature: 'Untere Grenztemperatur',
    registerAndEditAccumulatedTemperaturePoints:
      'Registrierung/Bearbeitung des Punktes zur Berechnung der kumulierten Temperatur',
    period: 'Zeitraum',
    accumulatedLowerLimitTemperature: 'Kumulierte untere Grenztemperatur',
    deleteAccumulatedTemperatureLocation:
      'Sind Sie sicher, dass Sie die integrierten Temperaturbeobachtungspunkte von 「{fieldName}」?',
    soilMoisture: 'Bodenfeuchte',
    soilTemperature: 'Bodentemperatur',
    precipitation: 'Niederschlag',
    soilMoistureList: 'Bodenfeuchte Liste',
    maxRegisterCount: '（Bis zu {count} Artikel）',
    soilConditionVeryWet: 'Überfeuchtigkeit',
    soilConditionWet: 'Feuchte',
    soilConditionDry: 'Trockenheit',
    soilConditionVeryDry: 'Übertrocknung',
    drainage: 'Bodenart',
    registerAndEditSoilMoisturePoints: 'Registrierung/Bearbeitung von Bodenfeuchte-Berechnungspunkten',
    soilMoistureConditionGood: 'Sandiger Lehm',
    soilMoistureConditionSlightlyBad: 'Lehm Lehm',
    soilMoistureConditionBad: 'Lehm',
    soilMoistureConditionSandyLoam: 'Sandiger Lehm',
    soilMoistureConditionClayLoam: 'Lehm Lehm',
    soilMoistureConditionClay: 'Lehm',
    deleteSoilMoistureLocation: 'Sind Sie sicher, dass Sie die Bodenfeuchte-Beobachtungspunkte in 「{fieldName}」?',
    deletedField: '< Das Feld wurde entfernt >',
    validateForStartDateBeforeYesterday: 'Das Startdatum muss mindestens einen Tag vor',
    validateForStartEndDateOrder: 'Das Enddatum muss später als das Startdatum sein',
    validateForStartEndDuration: 'Die Start- und Enddaten müssen innerhalb von {day} Tagen voneinander liegen',
    validateForStartNowDuration: 'Das Startdatum muss innerhalb von {day} Tagen nach dem aktuellen',
  },
  caster: {
    rtkInfo: 'RTK-Korrekturinformationen',
    rtkLog: 'Kommunikationsprotokoll',
    myBaseStationStatus: 'Status meiner Basisstation',
    howToSetupRtkBase:
      'Beim Senden von Korrekturdaten von einem Produkt eines anderen Unternehmens an "Meine Ladestation"',
    howToSetupRtkRover:
      'Beim Empfang von Korrekturinformationen von "Meine Basisstation" mit dem Produkt eines anderen Unternehmens',
    host: 'Host',
    port: 'Port',
    mountpoint: 'Einhängepunkt',
    derivedPassthroughLabel: ' (ohne Umwandlung)',
    derivedPassthroughCaption: 'Sendet die Korrekturdaten der Basisstation unverändert. Standardauswahl',
    derivedMsm4Label: ' (Kompatibilität)',
    derivedMsm4Caption: 'In MSM4 umgewandelt: für Empfänger, die mit dem neuesten Format (z. B. MSM7) instabil sind',
    derivedLegacyLabel: ' (für ältere Empfänger)',
    derivedLegacyCaption: 'In Legacy 1004/1012 umgewandelt: nur GPS+GLONASS',
    derivedNote:
      'Wenn keine Korrekturdaten empfangen werden oder kein FIX erreicht wird, versuchen Sie _MSM4 / _LEGACY. Bei Basisstationen anderer Hersteller sind diese Ausgaben ggf. nicht verfügbar.',
    baseStation: 'Basisstation',
    rover: 'Rover',
    userId: 'Benutzer-ID',
    ntripUserId: 'Ntrip-Benutzer-ID',
    ntripPassword: 'Ntirp-Passwort',
    showCaption: 'anzeigen',
    statusTab: 'Status',
    qualityTab: 'Qualität',
    mapTab: 'Karte',
    logTab: 'Verbindungsprotokoll',
    settingsTab: 'Einstellungen',
    baseShort: 'Basisstation',
    casterServer: 'Caster-Server',
    roverShort: 'Rover',
    receiving: 'Empfang',
    stale: 'Empfang stockt',
    noConnection: 'Nicht verbunden',
    lastReceivedAt: 'Zuletzt empfangen',
    disconnectedAt: 'Getrennt',
    summaryTitle: 'Empfang der Basisstation',
    lastSnapshotNote: 'Letzte Werte vor Trennung',
    noStatsData: 'Keine Daten von der Basisstation empfangen',
    bytesRate: 'Datenrate',
    messagesPerSecond: 'Nachrichten',
    epochInterval: 'Epochenintervall',
    uptime: 'Verbindungszeit',
    decodeErrors: 'Dekodierfehler',
    basePosition: 'Basisposition',
    antenna: 'Antenne',
    satellites: 'Satelliten',
    signals: 'Signale',
    meanCnr: 'Mittleres C/N0',
    msgType: 'Nachricht',
    msgCount: 'Anzahl',
    msgInterval: 'Intervall',
    msgLastSeen: 'Zuletzt empfangen',
    cnrChart: 'Mittleres C/N0 (dB-Hz)',
    satsChart: 'Satelliten',
    rateChart: 'Datenrate (Bytes/s)',
    epochChart: 'Epochenintervall (ms)',
    noHistoryData: 'Noch keine Verlaufsdaten',
    noTrackData: 'Keine GGA-Aufzeichnungen des Rovers',
    baseline: 'Basislinie',
    fixQuality: 'Fix-Qualität',
    ggaPoints: 'Aufgezeichnete Punkte',
    logBaseTitle: 'Verbindungen der Basisstation',
    logRoverTitle: 'Verbindungen der Rover',
    startAt: 'Start',
    endAt: 'Ende',
    inSession: 'Verbunden',
    userAgentLabel: 'Client',
    logNote: 'Zeigt Aufzeichnungen der letzten 24 Stunden',
  },
  print: {
    field: {
      fillSetting: 'Füllen Sie das Feld aus',
      backgroundWhiteColorSetting: 'Weißer Hintergrund',
      backgroundNoColorSetting: 'Kein Hintergrund',
      printText: 'Drucken',
      showFieldName: 'Feldname anzeigen',
    },
  },
  sortOptions: {
    title: 'Sortieren nach',
    field: {
      name: 'Name des Feldes',
      createdAt: 'Datum der Registrierung',
      lastModifiedDateTime: 'Geändertes Datum',
    },
  },
  fieldElevation: {
    title: 'Höhe',
    cantBuildBecauseNoTask:
      'Die Arbeitshistorie ist nicht vorhanden, so dass es nicht möglich ist, eine Höhenkarte zu erstellen.',
    nowBuilding: 'Vorbereiten... (Je nach Bereich des Feldes kann die Erstellung einige Zeit in Anspruch nehmen).',
    updatedAt: 'Erstellungsdatum',
    meshSize: 'Maschenweite',
    taskFetchLimit: 'Datenmenge',
    taskDateRange: 'Umfang',
    taskPointCount: 'Arbeitspunktzahl',
    editButton: 'bearbeiten',
    createButton: 'erstellen.',
    needStandardPlan: 'Die Höhenkarte erfordert den Standardplan.',
    taskFetchLimitHint:
      'Wenn es keinen Unterschied in der Höhe gibt, erhöhen Sie den Wert. Wenn es viel Lärm gibt, reduzieren Sie ihn.',
    creationFailedMessage: 'Das Erstellen der Height Map ist fehlgeschlagen.',
    gnssStatus: 'GNSS-Status',
    elevationRange: 'Höhenbereich',
    optionSetting: 'Optionseinstellung (beta)',
    minValue: 'Mindestwert',
    maxValue: 'Höchstwert',
    minIgnoreCaption: 'Erhebungen unterhalb dieses Wertes werden ignoriert',
    maxIgnoreCaption: 'Erhebungen über diesem Wert werden ignoriert',
    minValueNeedError: 'Bitte geben Sie einen Mindestwert an',
    maxValueNeedError: 'Bitte geben Sie den Höchstwert ein',
    minValueRangeError: 'Der Mindestwert muss kleiner sein als der Höchstwert',
    maxValueRangeError: 'Der Maximalwert muss größer als der Minimalwert sein',
    invalidOptionSettingError: 'Ungültige Optionseinstellung angegeben',
    dateRangeInput: 'Datumsbereich',
    oldestTaskDateInput: 'Anfangsdatum',
    newestTaskDateInput: 'Enddatum',
  },

  navi: {
    GeneralMainSettingMenuGnssSource: 'GNSS-Quelle',
    GeneralMainSettingGnssSourceInternal: 'Eingebautes GNSS-Terminal',
    GeneralMainSettingGnssSourceGPlus: 'AgriBus-G+',
    GeneralMainSettingGnssSourceG2: 'AgriBus-G2',
    GeneralMainSettingGnssSourceGMini: 'AgriBus-GMini',
    GeneralMainSettingGnssSourceGMiniR: 'AgriBus-GMiniR',
    GeneralMainSettingGnssSourceUsb: 'USB externes GNSS',
    GeneralMainSettingGnssSourceBluetooth: 'GNSS mit Bluetooth-Verbindung',
    GeneralMainSettingGnssSourceTcpPort: 'Interne Portkommunikation',
    GeneralMainSettingGnssSourceNtripClient: 'Ntrip Client (Trimble, Topcon)',
    GeneralMainSettingGnssSourceVirtual: 'Virtual',
  },

  ValidationTextRequired: 'Eingabe erforderlich',
  ResetPasswordTitle: 'Zurücksetzen und erneutes Ausgeben von Passwörtern',
  ResetPasswordButton: 'Passwort zurücksetzen',
  ResetPasswordDescription:
    'Sie erhalten eine E-Mail mit einem Link zum Zurücksetzen oder erneuten Ausgeben Ihres Passworts an Ihre registrierte E-Mail-Adresse. Befolgen Sie die Anweisungen in der E-Mail, um das Passwort zurückzusetzen oder neu zu vergeben.',
  ValidationBadEmail: 'Geben Sie die richtigen Email-Adressen ein',
  ChangePasswordButton: 'Passwort ändern',
  CreatePasswordButton: 'Erstelle ein Passwort',
  UnitTitle: 'Anzeigeeinheit',
  UnitMetric: 'Metrisch',
  UnitImperial: 'Imperiale Einheiten',
  UnitJpUnitsOfArea: 'Japanische Flächeneinheiten',
  UnitThUnitsOfArea: 'Thailändische Flächeneinheiten',
  NickNameHint: 'Name, der angezeigt werden soll',
  SendMeNews: 'Senden Sie die neuesten Informationen an eine E-Mail-Adresse',
  FreePlanDisplayName: 'Freierplan',
  StandardPlanDisplayName: 'Standardplan',
  ChangePasswordTitle: 'Passwort ändern',
  CreatePasswordTitle: 'Passwort erstellen',
  CurrentPasswordHint: 'Aktuelles Passwort',
  NewPasswordHint: 'Neues Passwort',
  SignInButton: 'Einloggen',
  ToResetPasswordButton: 'Passwort vergessen',
  DocFormFieldDetailFieldNameHint: 'Feldname',
  DocFormTaskRecordDetailFieldNameHint: 'Name des Arbeitsdatensatzes',
  DocFormTaskRecordDetailDescriptionHint: 'Anmerkungen',
  DocFormTabNameTaskRecordList: 'Aktivitätsverlauf',
  DocFormTabNameRefLineList: 'Leitlinie',
  DocFormTabNameGridPointsList: 'Mesh-Daten',
  DocFormTabNameFieldList: 'Feld',
  DocFormFieldRegisteredDateFormatBase: 'Datum: {createDate}',
  DocFormMenuItemSignOut: 'Ausloggen',
  DocFormFieldDetailDescriptionHint: 'Anmerkungen',
  StandardPlanIsNeededDialogMessage:
    'Sie können diese Funktion nutzen, indem Sie in regelmäßigen Abständen einen Standardplan (kostenlose 30-Tage-Testversion) erwerben.',
  SelectPlanDialogTitle: 'Plan auswählen',
  SelectPlanDialogRecommend: 'Empfohlen',
  SelectPlanDialogYearPlan: 'Jahresplan',
  SelectPlanDialogYearPlanGreatValue: '(Rabatt für 2 Monate)',
  SelectPlanDialogYearMonth: 'Monatsplan',
  StandardPlanPriceForMonthBatch: 'Jahresgebühr',
  StandardPlanPricePerMonth: '/ Monat',
  StandardPlanPricePerYear: '/ Jahr',
  StandardPlanPriceForYearNotice: '* Zahlung für 12 Monate',
  SelectPlanSubscribeYear: '30-tägige Testversion',
  SelectPlanSubscribeMonth: '30-tägige Testphase starten',
  selectPlanDataViewNote: '* Wenn Sie Ihr Abonnement nicht innerhalb von etwa einem Monat nach der Kündigung fortsetzen, werden vor der Kündigung aufgezeichnete Daten nicht mehr angezeigt (gilt ab dem 1. Oktober 2026). Bitte exportieren Sie benötigte Daten während der Laufzeit Ihres Abonnements.',
  DefaultRefLineTypeStraight: 'Linear',
  DefaultRefLineTypeCurved: 'Kurve',

  customSelectAll: 'Wählen Sie Alle',
  customUnSelectAll: 'Alles löschen',
  customRegistration: 'Registrierung',
  customUpdate: 'Update',
  customSearch: 'Suche',
  customDelete: 'Löschen',
  customAllow: 'Die Genehmigung',
  customDeny: 'Ablehnung',
  customDefault: 'Standard',
  customSelected: 'Auswählen',
  customSelectThis: 'Eine Auswahl treffen',
  customArea: 'Bereich',
  customNotAvailable: 'Nicht verfügbar',
  customEdit: 'Bearbeiten',
  customCancel: 'Stornieren',
  customNone: 'Keiner',
  customClose: 'Schließen',
  customFieldDrawHint: 'Klicken Sie auf die Karte, um Eckpunkte hinzuzufuegen, und bestaetigen Sie mit dem Haken (Zurueck-Button / Ruecktaste entfernt den letzten Punkt)',
  customBack: 'Zurück',
  customRefresh: 'Aktualisieren',
  customUpload: 'Hochladen',
  customPriceIncludingTax: 'Preis (inkl. MwSt.)',
  customPay: 'Zahlung',
  customCancelContract: 'Beendigung',
  customConfirmReally: 'Bist du sicher?',
  customRememberMe: 'Sparen',
  customLogin: 'Einloggen',
  customNowLoggingIn: 'Einloggen...',
  customEmail: 'Mail Adresse',
  customPassword: 'Passwort',
  customUser: 'Benutzer',
  customUserSettings: 'Benutzereinstellungen',
  customSentEMailMessage: 'E-Mail gesendet.',
  customNewPasswordReInput: 'Neues Passwort erneut eingeben',
  customValidationPasswordMinLength: 'Passwörter müssen mindestens {length} Zeichen enthalten',
  customValidationPasswordMaxLength: 'Zu lang',
  customValidationPasswordNotMatch: 'Die Passwörter stimmen nicht überein',
  customChangePasswordSuccess: 'Passwort geändert',
  customGoToLoginPageTitle: 'Kehren Sie zum Anmeldebildschirm zurück',
  customYouDontHaveAccount: 'Wenn Sie noch keinen Account haben',
  customRegisterAgriBusWeb: 'Registrieren Sie sich in AgriBus-Web',
  customChange: 'Nehmen Sie eine Änderung vor',
  customLanguage: 'Sprache',
  customSaveAction: 'Sparen',
  customSaveSuccess: 'Gerettet',
  customAddAction: 'Hinzufügen',
  customPlan: 'Planen',
  customPlanExpirationDate: 'Ablaufdatum: {expirationDate}',
  customPlanDescription: 'Um einen Plan zu ändern, müssen Sie dies in der Android-Anwendung (AgriBus-NAVI) tun.',
  customPlanOnly: 'Diese Funktion ist dem Standardplan gewidmet.',
  customDetail: 'Fortgeschritten',
  customDatePickerNullAlert: 'Wählen Sie zuerst das Datum aus.',
  customTaskNotFound: 'Arbeitshistorie nicht gefunden',
  customTaskNotFoundAtDate: 'Der Arbeitsverlauf konnte nicht gefunden werden. Arbeitsdatum: {date}',
  customErrorInitTasksFreePlan: 'Der kostenlose Plan ist auf maximal zwei Tage in der Geschichte begrenzt',
  customErrorInitTasksNoTasks: 'Wenn nichts angezeigt wird, bitte mit AgriBus-NAVI "synchronisieren"!',
  customErrorInitFieldsNoFields: 'Entweder keine Felder wurden registriert oder die AgriBus-NAVI nicht synchronisiert.',
  customColored: 'Farbkodierung',
  customHeight: 'Höhe',
  customHeightMap: 'Höhenkarte',
  customSpeed: 'Geschwindigkeit',
  customDate: 'Datum und Uhrzeit',
  customWorkWidth: 'Arbeitsbreite',
  customWorkedArea: 'Arbeitsbereich',
  customOverlappedArea: 'Überlappter Bereich',
  customTaskRecordEfficiency: 'Arbeitseffizienz',
  customDistance: 'Reiseentfernung',
  customWorkedTime: 'Arbeitszeit',
  customAverageSpeed: 'Durchschnittsgeschwindigkeit',
  customWorker: 'Operator',
  customDocFormTaskRecordDistanceOfFormatBase: '{distance} (Mittelwert {speed})',
  customDocFormTaskRecordWorkedAreaPercentageFormatBase: '{percentage}% während {fieldArea}',
  customDocFormTaskRecordWorkedAreaInfoFormatBase: '{areaPercentageText}, {efficiencyText}/h',
  customPageSuffix: 'Seite',
  customDisplayCount: 'Anzahl der angezeigten Elemente',
  customTotalCount: 'Alle {count} Einträge',
  customListingModeSelf: 'Nur du selbst',
  customListingModeAll: 'Follow-up einbeziehen',
  customIconSettings: 'Icon-Einstellung',
  customAccountHeader: 'Konto',
  customConnectionHeader: 'Verbindung',
  customConnectionTitle: 'Verbindung',
  customFollowRequest: 'Folgeantrag',
  customFollow: 'Nachverfolgen',
  customUnfollow: 'Lassen Sie Follow los',
  customFollowing: 'Folgen',
  customFollower: 'Anhänger',
  customHaveNoFollowings: 'Niemand folgt.',
  customHaveNoFollowers: 'Keine Anhänger',
  customInbox: 'Erhalten',
  customOutbox: 'Senden',
  customInboxEmpty: 'Keine Folgeanträge erhalten',
  customOutboxEmpty: 'Keine Follow-Anfragen gesendet',
  customSendFollowRequest: 'Follow Request senden',
  customSendFollowRequestMessage: 'Ich habe eine Folgeanfrage gesendet.',
  customFollowRequestSelfRequestError: 'Ich kann keine Folgeanfragen an mich selbst senden',
  customAllowFollowRequest: 'Ich habe die Folgeanfrage von {fromNickname} genehmigt.',
  customUnfollowMessage: 'Folgen abgebrochen',
  customUpdatedIconMessage: 'Icon geändert',
  customIconNowSelected: 'Momentan ausgewählt',
  customIcon: 'Standardsymbol',
  customIconSettingsDescription: 'Wir empfehlen, dass Sie Ihr eigenes Symbol festlegen.',
  customIconChangeToIcon: 'Zum Standard wechseln',
  customGravatarIcon: 'Gravatar',
  customIconSettingsGravatarDescription: 'Dies ist nützlich, wenn Sie Symbole für das Gravatar festgelegt haben.',
  customIconChangeToGravatar: 'Wechseln Sie zu Gravatar',
  customCustomIcon: 'Brauch',
  customIconSettingsCustomDescription:
    'Sie können Ihre Lieblingsfotos einstellen. Bereiten Sie eine JPEG-oder PNG-Datei vor.',
  customIconChangeToCustom: 'Ändern Sie zur Gewohnheit',
  customIconReUpload: 'Wiederholen Sie den Upload',
  customTemperature: 'Temperatur',
  customHumidity: 'Feuchtigkeit',
  customWind: 'Windgeschwindigkeit',
  customPressure: 'Luftdruck',
  customSunrise: 'Sonnenaufgang',
  customSunset: 'Sonnenaufgang',
  customShowAllCropsDescription: 'Zeige alles',
  customShowCurrentCropsDescription: 'Nur aktuelle anzeigen',
  customProduct: 'Erstellen',
  customProductsNotFound: 'Erstellung nicht gefunden',
  customColor: 'Farbe',
  customYear: 'Jahr',
  customCrop: 'Ernte',
  customCropVariety: 'OBJEKTTYP',
  customDeleteCropConfirmationMessage:
    'Möchten Sie {cropYear} {cropName} {cropVariety} wirklich entfernen? (Zugehörige Daten werden ebenfalls gelöscht.)',
  customOperationType: 'Aufgabe',
  customFilter: 'Filter',
  customOutOfField: 'Außerhalb des Feldes',
  customBillingPlan: 'Preisplan',
  customBillingAndPayment: 'Gebühren und Bezahlung',
  customBillingMethod: 'Bezahlverfahren',
  customBillingExistingCard: 'Registrierte Karte',
  customBillingAddNewCard: 'Neue Karte hinzufügen',
  customBillingMethodConfirm: 'Überprüfen Sie die Zahlungsmethode',
  customBillingHistory: 'Zahlungsbeleg',
  customCreditCard: 'Kreditkarte',
  customCreditCardLast4: 'Letzten 4 Ziffern',
  customCreditCardNameOnCard: 'Name auf der Karte',
  customCreditCardInfo: 'Karteninformationen',
  customCreditCardAddCard: 'Karte hinzufügen',
  customCreditCardAddCardCaution1:
    'Die Karte ist zu diesem Zeitpunkt kostenlos, wird jedoch als Karte für zukünftige Zahlungen verwendet.',
  customCreditCardAddCardCaution2:
    'Wenn Sie Ihre Rechnung bezahlen möchten, wenden Sie sich bitte an contact@agri-info-design.com, bevor Sie Ihre Karte registrieren lassen.',
  customCreditCardNoCard: 'Es wird keine Kreditkarte gespeichert',
  customCreditCardDeleteFailure: 'Die Kartenabmeldung ist fehlgeschlagen',
  customMyProducts: 'Meine Produkte',
  customMyProductsList: 'Produktliste',
  customMyProductProduct: 'Produkt',
  customMyProductProductNumber: 'Produktnummer',
  customMyProductDataPlan: 'Datentarif',
  customMyProductDataPlanSubscribe: 'Datenplanabonnements',
  customMyProductDataPlanSubscribeSuccessMessage: 'In Kürze wird die {productNumber} 3G-Kommunikation aktiviert.',
  customMyProductDataPlanExpiredMessage: 'Das Ablaufdatum ist abgelaufen. {expiredDate}',
  customMyProductDataPlanCancelConfirmationMessage:
    'Wenn Sie Ihr Abonnement kündigen, wird die 3G-Kommunikation deaktiviert. Außerdem können Sie den Differenzbetrag nicht erstatten, auch wenn die Vertragslaufzeit noch besteht. Sie können das Abonnement jedoch wieder kündigen. Möchten Sie den Vorgang wirklich abbrechen?',
  customRealTime: 'Echtzeit',
  customRealTimeSettings: 'Echtzeit-Konfiguration',
  customModel: 'Modell',
  customSystemVersion: 'Systemversion',
  customWebMarkerIcon: 'Symbol',
  customWebMarkerSetting: 'Markereinstellungen',
  customWebMarkerName: 'Markierungsname',
  customWebMarkerColor: 'Markierungsfarbe',
  customRealtimeChooseYourDevice: 'Wählen Sie das Gerät aus',
  customRealtimeDeviceNotActive: 'Läuft derzeit nicht',
  customElevation: 'Höhe',
  customGnss: 'GNSS',
  customSatellites: 'Satellit',
  customFirmwareVersion: 'Firmware Version',
  customHasFirmwareUpdate: 'Habe die neuesten Updates',
  customFirmwareDownloadMessage: 'Neue Versionen {newestFirmwareVersion} wurden veröffentlicht.',
  customDownload: 'Herunterladen',
  customFieldRegistration: 'Neue Registrierung des Feldes',
  customFieldCreateWithMapTitle: 'Ein Feld auf einer Karte erstellen',
  customFieldCreateWithMapTitleDescription: 'Erstellen Sie ein neues Feld auf der Karte',
  customFieldCreateWithMapButton: 'Erstellen',
  customFieldCreateWithMapFieldName: 'Feldname',
  customFieldCreateWithMapLoadingMap: 'Karte wird geladen',
  customFieldCreateWithMapCreate: 'Erstellen',
  customFieldCreateWithMapCreateFinishedMessage: 'Das Feld {fieldName} wurde erstellt',
  customFieldCreateWithMapCreateErrorMessage: 'Fehler beim Erstellen des Feldes {fieldName}',
  customFieldCreateWithMapNoFieldMessage: 'Erstellen Sie ein Feld auf der Karte',
  customFieldCreateWithMapNoFieldNameMessage: 'Geben Sie den Feldnamen ein',
  customFieldCreateWithMapTooManyFieldsMessage: 'Es kann nur ein Feld erstellt werden.',
  customFieldUploadTitle: 'KML/Shapefile-Upload',
  customFieldUploadMessage: 'Laden Sie Ihre KML/KMZ-Dateien oder das Shapefile hoch',
  customFileUploadShapefileDescription:
    'Das Shapefile muss eine zip-archivierte (komprimierte) Datei enthalten, die die folgenden Dateien enthält',
  customFieldUploadFileInput: 'Wählen Sie eine Datei aus',
  customFileUploadShpDescription: '.shp (Geländeinformationen)',
  customFileUploadShxDescription: '.shx (Indexinformationen)',
  customFileUploadDbfDescription: '.dbf (Attributinformationen)',
  customFileUploadPrjDescription: '.prj (Informationen zum geografischen Koordinatensystem)',
  customFileUploadPrjCaution: '. prj ist erforderlich, um die Koordinatendaten korrekt zu lesen.',
  customFileUploadTextEncodingDescription: 'Bitte ändern Sie es, wenn der Attributname usw. verstümmelt ist',
  customFileUploadAttributeNameForFieldName: 'Attributname Wird als Feldname verwendet',
  customFileUploadFieldImportStart: '{count} Beginnen Sie mit dem Importieren eines Pinselfelds',
  customFileUploadImportCheckTitle: 'Importieren',
  customFileUploadFieldImportStartedMessage:
    'Import eines Feldes gestartet. Wenn die Anzahl groß ist, kann der Vorgang einige Minuten dauern.',
  customFieldUploadErrorMessage: 'Hochgeladene Datei kann nicht gelesen werden',
  customFieldThisFieldName: 'Feld "{fieldName}"',
  customFieldUnknownFieldName: 'Dieses Feld',
  customFieldNoName: 'Kein Feld',
  customFieldDeleteAlertWithTask:
    'Es gibt {count} Arbeitsgeschichten zu {fieldName}. Wenn Sie es löschen, gehen die Feldinformationen in der entsprechenden Arbeitshistorie verloren, aber ist es OK?',
  customFieldDeleteAlertWithoutTask: 'Möchten Sie {fieldName} wirklich entfernen?',
  customTextEncoding: 'Codierung',
  customFieldImportFinishedMessage: '{count} Strichfeld (er) erfolgreich importiert...',
  customFieldImportErrorMessage: 'Das Feld konnte nicht importiert werden.',
  customFieldCount: 'Feldanzahl: {count} Anrufe',
  customExport: 'Exportieren',
  customTaskExport: 'Aktivitätsverlauf exportieren',
  customTaskWhatIsAgriBusFormat:
    'AgriBus-Formate sind durch Tabulatoren getrennte Texte, die einfach zu verarbeiten sind.',
  customTaskNowDeveloping: 'In Entwicklung',
  customTaskNowDevelopingDescription: 'In Kürze können Sie in anderen Formaten ausgeben.',
  customTaskStartExporting: 'Starten Sie den Export',
  customTaskNowExporting: 'Exportieren...',
  customTaskDownloadReady: 'Bereit zum Download',
  customFieldHeader: 'Feld',
  customDarkMode: 'Dunkler Modus',
  customNewRegistration: 'Neuer Eintrag',
  customCreateNew: 'Neu erstellen',
  customImport: 'Importieren',
  customListDisplay: 'Listenansicht',
  customCardDisplay: 'Kachelansicht',
  customCalendarDisplay: 'Kalenderanzeige',
  customFieldsList: 'Liste der Felder',
  customPleaseSignUpFromAndroidApplication:
    'Melden Sie sich über die Android-App an <span class="aid-logotype">AgriBus-NAVI</span>.',
  customWhatIsAgribusNAVI: 'Was ist <span class="aid-logotype">AgriBus-NAVI</span>',
  customAgriBusNAVIDescription:
    '<span class="aid-logotype">AgriBus-NAVI</span> ist eine AndroidOS GPS-Guidance-App (GNSS Guidance), die in landwirtschaftlichen Maschinen und Fahrzeugen wie Lohnunternehmern, Mähdreschern und selbstfahrenden Feldspritzen installiert werden kann, um Sie bei der Durchführung einfacher Arbeiten auf dem Feld zu unterstützen. Wenn Sie es auf Ihrem Smartphone oder Tablet installieren und während der Überprüfung der Bildschirmanzeige ausführen, können Sie landwirtschaftliche Arbeiten in einem weiten Bereich direkt und in gleichmäßigen Abständen ausführen.',
  customProductDetails: 'Produktdetails',
  aid: {
    calendar: {
      month: 'Monat',
      week: 'Woche',
      day: 'Tag',
      fourdays: '4 Tage',
    },
  },
  customTaskFilterAllSelect: 'Alle arbeiten',
  customTaskFilterGetError: 'Fehler beim Abrufen der Filterinformationen',
  customTaskFilterPostError: 'Fehler beim Registrieren der Filterinformationen',
  customTaskFilterPutError: 'Fehler beim Aktualisieren der Filterinformationen',
  customTaskFilterDeleteError: 'Fehler beim Löschen der Filterinformationen',
  customTaskFilterPostSucceed: '"{filtername}" Registriert',
  customTaskFilterPutSucceed: '"{filtername}" Wurde aktualisiert',
  customTaskFilterSetDefault: 'Setzen Sie "{filtername}" als Standardfilter',
  customTaskFilterDeleteSucceed: 'Filterinformationen wurden gelöscht',
  customTaskFilterSelectCheckError: 'Der entsprechende Filter existiert nicht. Bitte wählen Sie einen Filter aus',
  customTaskFilterDuplicateCheckError: 'Doppelter Filtername',
  customTaskFilterNotEnteredCheckError: 'Es wurde kein Filtername eingegeben',
  customTaskFilterStringNarrowing: 'String Verengung',
  customTaskFilterMakeDefault: 'Verwenden Sie immer diesen Filter',
  customTaskFilterName: 'Filtername',
  customTaskFilterDeleteMsg: '"{filtername}" Möchten Sie löschen?',
  customTaskFilterDialogTitle1: 'Arbeitsverlauf filtern',
  customTaskFilterDialogTitle2: 'Wenden Sie gespeicherte Filtereinstellungen an',
  customTaskFilterCreateNew: 'Erstellen Sie eine neue Filtereinstellung',
  customTaskFilterEdit: 'Bearbeiten eines Filters',
  customTaskFilterSetting: 'Einstellung des Filters',
  customTaskFilterCurrent: 'Strom-Filter',
  customTaskFilterNoTasksError:
    'Aufgrund der Einstellung des Filters "{filtername}" ist die Anzahl der angezeigten Elemente 0.',
  customTaskFilterAreaZeroHidden: 'Arbeit mit Arbeitsbereich Null ausschließen',
  customTaskFilterDistanceUnderTenHidden: 'Ausgeschlossen sind Arbeiten mit weniger als 10m (10.936yd) Laufleistung',
  customTaskFilterNoField: 'Kein Feld',
  customTaskFilterNoCrop: 'Keine Ernte',
  customTaskFilterOutOfFieldHidden: 'Schließt Aufgabengeschichte außerhalb des Feldes aus',
  customSimpleSignUpNow: 'Registrierung',
  customSimpleSignUpSuccess:
    'Eine E-Mail wurde gesendet, um die Registrierung abzuschließen. Bitte überprüfen Sie Ihre Mailbox',
  customEnterpriseInviteSuccess: 'Ich habe Ihnen eine E-Mail-Einladung geschickt',
  customSimpleSignUpFailed: 'Registrierung fehlgeschlagen',
  customSimpleSignUpUserAlreadyExists: 'Es liegt ein Problem mit Ihrer E-Mail-Adresse vor',
  customSimpleSignUpServerError: 'Bei der Registrierung ist ein Fehler aufgetreten',
  customDateFilterStartDate: 'Startdatum filtern',
  customDateFilterEndDate: 'Enddatum filtern',
  customDateFilterCalendarType: 'Kalendertyp',
  customDateFilterCalendarTypeDate: 'Tag',
  customDateFilterCalendarTypeMonth: 'Monat',
  customDateFilterSetBotton: 'Stellen Sie ein',
  customDateFilterRangeError: 'Das Startdatum liegt nach dem Enddatum.Bitte wählen Sie erneut ein Datum.',
  customCurrency: 'Währung',
  customBillingCurrencyJPY: 'Japanischer Yen',
  customBillingCurrencyUSD: 'US Dollar',
  customBillingMenu: 'Verwaltung des Nutzungsplans',
  customBillingMore: 'Erfahren Sie mehr',
  customBillingPurchase: 'Probieren Sie die kostenlose Testversion 30 Tage lang aus',
  customBillingPurchaseWithoutTrial: 'Upgrade',
  customBillingPlanInfo: 'Planen Sie Informationen',
  customBillingNowPlan: 'Dein Plan',
  customBillingTrial: 'Versuch',
  customBillingCancellation: 'Stornierung',
  customBillingContractPeriod: 'Vertragslaufzeit',
  customBillingAmount: 'Betrag',
  customBillingAlertMustRegisterCard: 'Um zu kaufen, müssen Sie im Voraus eine Kreditkarte registrieren.',
  customBillingMessageUnsubscribe: 'Bezahlte Pläne storniert.',
  customBillingMessageSubscribe: 'Vielen Dank für Ihren Kauf',
  customBillingMessageUnSubscribeGoogle:
    'Sie zahlen derzeit bei Google Play Store. Bitte stornieren Sie bei Google Play Store.',
  customBillingReceipt: 'Rechnungen/Belege',
  customBillingMessageCancelStandardPlan:
    'Wenn Sie Ihren bezahlten Plan kündigen, können Sie den Dienst noch für den Zeitraum nutzen, für den Sie bezahlt haben. Wenn ich hier kündige, bin ich nach {date} automatisch im kostenlosen Tarif, ist das noch korrekt?',
  customBillingMessageCancelTrial:
    'Sie befinden sich gerade in der Testphase, aber wenn Sie hier kündigen, kehren Sie sofort zum kostenlosen Tarif zurück. Bitte beachten Sie, dass Sie sich nach der Kündigung für einen neuen kostenpflichtigen Tarif anmelden können.',
  customBillingStandardDescription:
    'Ein Monat kostenlos mit einem kostenpflichtigen Jahresabonnement; nutzen Sie alle Funktionen, einschließlich der unbegrenzten Datenspeicherung von AgriBus-Web und der Anzeige der Fahrzeugposition in Echtzeit, der Kurvenführung von AgriBus-NAVI und der Informationsschale!',
  customAdRow1_1: 'Revolutionieren Sie die landwirtschaftlichen Arbeitsdaten',
  customAdRow1_2: 'mithilfe des Standardplan',
  customAdRow2_1: 'Drei Vorteile',
  customAdRow2_2: 'Unbegrenzte Speicherung und Export von Daten',
  customAdRow2_3: 'Echtzeitanzeige der Fahrzeugposition',
  customAdRow2_4: 'Verwendung von AgriBus-Caster',
  customAdRow3_1: 'Drei Vorteile',
  customAdRow3_2: 'Fügen Sie der Arbeitsstrecke Höhenunterschiede, Laufgeschwindigkeit usw. hinzu',
  customAdRow3_3: 'Speichern und Abrufen der Basislinie',
  customAdRow3_4: 'Kurvenführung anwenden',
  customOAuthMessage: 'Während der Authentifizierung...',
  customGoogleOAuthBtn: 'Melden Sie sich mit Google an',
  customGoogleOAuthSignUpBtn: 'Melden Sie sich bei Google an',
  customOAuthError: 'Fehler im OAuth-Authentifizierungsprozess',
  customOAuthGetUserInfoError: 'Beim Abrufen der OAuth-Informationen ist ein Fehler aufgetreten',
  customOAuthServerError: 'Bei der Registrierung der OAuth-Anmeldeinformationen ist ein Fehler aufgetreten',
  customOAuthFailed: 'OAuth- Authentifizierung fehlgeschlagen',
  customToBillingPage: 'Zum Standardplan-Kaufbildschirm',
  customTasksListFreePlanMsg:
    'Im Freierplan wird die Arbeitshistorie nur für 2 Tage angezeigt. Wenn Sie den Standardplan abonnieren, können Sie eine unbegrenzte Speicherdauer haben.',
  customEnterprise: 'Unternehmen',
  customEnterpriseSetting: 'Unternehmenseinstellungen',
  customEnterpriseManagement: 'Unternehmensführung',
  customWhatIsEnterprise: 'Was ist AgriBus-Web Enterprise?',
  customEnterpriseRegistration: 'Melden Sie sich für den Unternehmensplan an',
  customPleaseContinueToRegisterForEnterprise:
    'Bitte setzen Sie den Registrierungsprozess für AgriBus-Web Enterprise mit der E-Mail fort, die Sie erhalten haben.',
  customPleaseInputOrganizationName: 'Bitte geben Sie den Namen Ihrer Organisation ein.',
  customEnterpriseName: 'Name des Unternehmens',
  customMaxOfMemberThisMonth: 'Maximale Anzahl von Mitgliedern in diesem Monat',
  customExpectedPaymentAmountForThisMonth: 'Geschätzter Zahlungsbetrag für diesen Monat',
  customDateOfPayment: 'Datum der Zahlung',
  customPaymentHistory: 'Zahlungshistorie',
  customEditEnterpriseName: 'Unternehmensname bearbeiten',
  customOrganization: 'Organisation',
  customOrganizationName: 'Name der Organisation',
  customAdministrator: 'Verwalter',
  customOrganizationList: 'Organigramm',
  customNewOrganization: 'Erstellen einer neuen Organisation',
  customCreateOrganization: 'Eine Organisation erstellen',
  customEditOrganizationName: 'Organisationsname bearbeiten',
  customTeam: 'Mannschaft',
  customTeamList: 'Liste der Mannschaften',
  customMyTeam: 'Meine Mannschaft',
  customMyTeamList: 'Meine Teamliste',
  customNewTeam: 'Ein neues Team erstellen',
  customTeamName: 'Name der Mannschaft',
  customCreateTeam: 'Ein Team erstellen',
  customRemoveFromTeam: 'Aus der Mannschaft entfernt',
  customEditTeam: 'Team Bearbeiten',
  customMember: 'Mitglied',
  customMemberName: 'Name des Mitglieds',
  customAddNewMember: 'Ein Mitglied hinzufügen',
  customNumberOfMember: 'Zahl der Mitglieder',
  customInviteMembers: 'Mitglieder einladen',
  customSendInvitationEmail: 'Einladungs-E-Mail senden',
  customPleaseEnterTheNameOfTheMember: 'Bitte geben Sie die Namen der Mitglieder ein, die Sie einladen',
  customMemberList: 'Mitglieder-Liste',
  customEditMember: 'Mitglied bearbeiten',
  customInviting: 'Während einer Einladung',
  customRestrictFollow: 'Beschränkung befolgen',
  customPermission: 'Zugangsrechte',
  customPermissionName: 'Name der Zugangsberechtigung',
  customRoleName: 'Name der Rolle',
  customAction: 'Aktion',
  customIndividualCreation: 'Individuelle Erstellung',
  customConfirmTeamDeletion: 'Darf ich dieses Team absetzen?',
  customConfirmMemberRemovalFromTeam: 'Darf ich dieses Mitglied aus dem Team entfernen?',
  customSelectTeamsForMemberToJoinDialogTitle: 'Teams auswählen, denen das Mitglied beitreten wird',
  customSelectTeamsForMemberToJoinDialogOK: 'Zum ausgewählten Team hinzufügen',
  customSelectMembersAddToTeamDialogTitle: 'Bitte wählen Sie Mitglieder aus, die dem Team beitreten möchten',
  customSelectMembersAddToTeamDialogOK: 'Fügen Sie die ausgewählten Mitglieder hinzu.',
  customFollowMembersDialogTitle: 'Bitte wählen Sie ein Mitglied aus, dem Sie folgen möchten',
  customFollowMembersDialogOK: 'Dem ausgewählten Mitglied folgen',
  customTeamFollowSelectDialogTitle: 'Bitte wählen Sie ein Team aus, dem Sie folgen möchten',
  customTeamFollowSelectDialogOK: 'Folgen Sie den ausgewählten Teams',
  customPleaseConfirm: 'Bitte überprüfen Sie dies.',
  customEnterpriseSignUpForPleaseConfirmDescription1:
    'Benutzer mit der angegebenen E-Mail-Adresse sind im Standard- oder Enterpriseplan enthalten.',
  customEnterpriseSignUpForPleaseConfirmDescription2:
    'Wenn Sie einen Standardplan haben, melden Sie sich bitte für einen Enterpriseplan an, nachdem Sie diesen gekündigt haben.',
  customEnterpriseSignUpForFreePlanDescription:
    'Benutzer mit der angegebenen E-Mail-Adresse erhalten einen Freierplan. Kann ich zum Enterpriseplan wechseln?',
  customEnterpriseSignUpForStandardPlanDescription:
    'Der Benutzer mit der angegebenen E-Mail-Adresse hat seinen Standardplan gekündigt, er ist aber noch aktiv. Möchten Sie zum Enterprise-Tarif wechseln? (Bitte beachten Sie, dass dem Benutzer sowohl der Standard- als auch der Enterprise-Tarif in Rechnung gestellt werden, wenn er noch Schulden für den Standard-Tarif hat.)',
  customAddFollowMembers: 'Ein nachfolgendes Mitglied hinzufügen',
  customAddFollowTeams: 'Ein Nachfolgeteam hinzufügen',
  customBillingMaxMember: 'Maximale Anzahl von Mitgliedern',
  customCreditCardRegistration: 'Kreditkarten-Registrierung',
  customNext: 'Nächste',
  customGoBackOneStep: 'Zurück zum vorherigen',
  customRestriction: 'Beschränkung',
  customMemberSuspension: 'Sind Sie sicher, dass Sie dieses Mitglied nicht mehr verwenden wollen?',
  customResumeMemberUsage: 'Sind Sie sicher, dass Sie dieses Mitglied wieder verwenden möchten?',
  customRestart: 'neu starten',
  customSuspended: 'Suspendiert',
  customAddToExistingTeam: 'Zum Team hinzufügen',
  customFollowFunction: 'Funktion verfolgen',
  customAllowToAddAndRemoveFollow: 'Erlauben Sie das Hinzufügen und Entfernen folgen',
  customAllowToAddAndRemoveFollowDescription:
    'Diesem Mitglied ist es nicht gestattet, selbst Anhänger hinzuzufügen oder zu entfernen.',
  customNotAllowToAddAndRemoveFollow: 'Hinzufügen und Entfernen nicht zulassen folgen',
  customNotAllowToAddAndRemoveFollowDescription:
    'Diesem Mitglied steht es frei, Follower hinzuzufügen und zu entfernen.',
  customEnterprisePlanDisplayName: 'Unternehmensplan',
  customPricePerMember: 'Preis pro Mitglied.',
  customPerMember: 'Pro Mitglied',
  customNotesOnPlanSelection:
    'Der in Rechnung gestellte Betrag ist die maximale Anzahl von Mitgliedern im Abrechnungsmonat x Einheitspreis.',
  customDueDateForFirstRepayment: 'Fälligkeitsdatum für die erste Rückzahlung',
  customEnterprisePlanStart: 'Start',
  customUnsubscribeFromEnterprise: 'Abmeldung vom Unternehmensplan.',
  customReturnAgriBusWeb: 'Zurück zu Agri-Bus Web',
  customAboutCreditCardPayment: 'Über Kreditkartenzahlung',
  customClickHereUnsubscripbeFromEnterprise: 'Klicken Sie hier, um sich vom Unternehmensplan abzumelden.',
  customEnterpriseWithdrawText1:
    'Aufgrund des Austritts aus der Mitgliedschaft wird die Rechnung für diesen Monat die letzte Rechnung für diesen Monat sein, und es werden keine weiteren Zahlungen geleistet.',
  customEnterpriseWithdrawText2:
    'Wir werden auch in Zukunft jedes Produkt der AgriBus-Serie weiterentwickeln, wenn Sie also eine Chance haben, schauen Sie bitte noch einmal vorbei.',
  customEnterpriseWithdrawText3:
    'Wir möchten Ihnen danken, dass Sie jedes einzelne Produkt der AgriBus-Serie benutzt haben, auch wenn es nur für einen Moment war. Vielen Dank für Ihr Interesse an unseren Produkten.',
  customErrorEnterpriseWithdraw:
    'Sie haben es versäumt, Ihren Enterprise-Plan zu stornieren. Bitte versuchen Sie es erneut.',
  customGuidanceInterval: 'Führungsintervall',
  customWorkingWidth: 'Arbeitsbreite',
  customRefLineLength: 'Länge der Führungslinie',
  customRefLine: 'Referenzlinie',
  customExportRefLine: 'Exportieren einer Basislinie',
  customDirecton: 'Richtung',
  customShowTaskDetailError:
    'Es gibt keine Arbeitshistorie; sie kann mit AgriBus-NAVI nicht synchronisiert oder gelöscht worden sein.',
  customFileUploadAttributeNameForRefLineName: 'Attributname, der als Basislinie verwendet werden soll',
  customFileUploadRefLineImportStart: 'Beginnen Sie mit der Aufnahme von {count} Referenzlinien.',
  customFileUploadShapefileDescriptionForRefLines:
    'Das Shapefile erfordert eine (komprimierte) Zip-Archivdatei nur für die folgenden Dateien',
  customFileUploadShpDescriptionForRefLines: 'Swaths.shp (Topographische Informationen)',
  customFileUploadShxDescriptionForRefLines: 'Swaths.shx (Index-Informationen)',
  customFileUploadDbfDescriptionForRefLines: 'Swaths.dbf (Attribut-Informationen)',
  customRefLineImportFinishedMessage: 'Es ist uns gelungen, {count} Referenzlinien zu erfassen.',
  customRefLineImportErrorMessage: 'Es ist mir nicht gelungen, eine Grundlinie zu erfassen.',
  customRefLineAddTitle: 'Registrierung einer neuen Referenzlinie',
  customRefLineImportTitle: 'Shapefile hochladen',
  customRefLineImportText: 'Laden Sie Ihr Shapefile hoch',
  customRefLineImportText2: 'Es können nur vom Trimble CFX-750 ausgegebene Referenzlinien importiert werden.',
  customRefLineCreateTitle: 'Erstellen einer Grundlinie auf einer Karte',
  customRefLineCreateText: 'Erstellen einer Grundlinie auf der Karte',
  customRefLineUploadTitle: 'Hochladen einer Grundlinie',
  customRefLineNameHint: 'Referenzzeilenname',
  customRefLineDeleteAlert: 'Sind Sie sicher, dass Sie {refLineName} löschen möchten?',
  customRefLineDeleteUnknownName: 'Diese laufende Referenzlinie',
  customRefLineDeleteKnownName: 'Referenzzeile "{refLineName}".',
  customRefLineDeleteError: 'Das Löschen der Referenzzeile ist fehlgeschlagen.',
  customThunderstormWithLightRain: 'Gewitter mit leichtem Regen',
  customThunderstormWithRain: 'Gewitter mit Regen',
  customThunderstormWithHeavyRain: 'Gewitter mit Starkregen',
  customThunderstormWithLightDrizzle: 'Gewitter mit leichtem Nieselregen',
  customThunderstormWithDrizzle: 'Gewitter mit Nieselregen',
  customThunderstormWithHeavyDrizzle: 'Gewitter mit starkem Nieselregen',
  customThunderstormWithHail: 'Gewitter mit Hagel',
  customLightDrizzle: 'Licht Nieselregen',
  customDrizzle: 'Nieselregen',
  customHeavyDrizzle: 'Starker Nieselregen',
  customLightRain: 'Leichter Regen',
  customModerateRain: 'Mäßiger Regen',
  customHeavyRain: 'Starkregen',
  customFreezingRain: 'Gefrierender Regen',
  customLightShowerRain: 'Leichter Regenschauer',
  customShowerRain: 'Dusche regen',
  customHeavyShowerRain: 'Starker Regenschauer',
  customLightSnow: 'Leichter Schnee',
  customSnow: 'Schnee',
  customHeavySnow: 'Schwerer Schnee',
  customMixSnowRain: 'Schnee/Regen mischen',
  customSleet: 'Schneeregen',
  customHeavySleet: 'Starker Schneeregen',
  customSnowShower: 'Schneeschauer',
  customHeavySnowShower: 'Starker Schneeschauer',
  customFlurries: 'Wirbelstürme',
  customMist: 'Nebel',
  customSmoke: 'Rauch',
  customHaze: 'Dunst',
  customSandDust: 'Sand/Staub',
  customFog: 'Nebel',
  customFreezingFog: 'Gefriernebel',
  customClearSky: 'Klarer Himmel',
  customFewClouds: 'Wenige Wolken',
  customScatteredClouds: 'Vereinzelte Wolken',
  customBrokenClouds: 'Gebrochene Wolken',
  customOvercastClouds: 'Bedeckte Wolken',
  customUnknownPrecipitation: 'Unbekannt Niederschlag',
  customWeatherInfoTitle: 'Wetter-Informationen',
  customWeatherDescriptionTitle: 'Wetter',
  customWindSpeedTitle: 'Windgeschwindigkeit',
  customTemperatureTitle: 'Temperatur',
  customRelativeHumidityTitle: 'Feuchtigkeitsgrad',
  customNumOfSatellites: 'Anzahl der Satelliten',
  customGnssStatus: 'GNSS-Status',
  customLeftRightMisalignment: 'Ausrichtungsfehler',
  customAzimuthShift: 'Azimutverschiebung',
  customGradient: 'Gradient',
  customTimeOfAcquisition: 'Erfassungszeit',
  customWorkOverview: 'Arbeitsübersicht',
  customImageStorage: 'Bildspeicherung',
  customMapGaugeDescriptionNone: 'Die Füllung der Arbeit ohne Farbcodierung wird angezeigt',
  customMapGaugeDescriptionHeight: 'Der Höhenunterschied des Werks wird durch Farbe angezeigt',
  customMapGaugeDescriptionSpeed: 'Die Geschwindigkeit der Arbeit wird durch Farbe angezeigt',
  customMapGaugeDescriptionNumOfSatellites:
    'Die Anzahl der Positionierungssatelliten zum Zeitpunkt des Betriebs wird in verschiedenen Farben angezeigt',
  customMapGaugeDescriptionGnssStatus: 'Der GNSS-Status zum Zeitpunkt der Arbeit wird farblich angezeigt.',
  customMapGaugeDescriptionLeftRightMisalignment:
    'Die Links-Rechts-Abweichung von der Führung während des Betriebs wird farblich angezeigt.',
  customMapGaugeDescriptionAzimuthShift: 'Farbcodierte Anzeige der Fehlausrichtung mit Führung während des Betriebs',
  customMapGaugeDescriptionGradient:
    'Die Neigung bei der Arbeit wird in verschiedenen Farben angezeigt (nur G2, GMiniR, Gmini).',
  customPrecipitationTitle: 'Niederschlag',
  customWeathercomTornado: 'Tornado',
  customWeathercomTropicalStorm: 'Tropensturm',
  customWeathercomHurricane: 'Wirbelsturm',
  customWeathercomStrongStorms: 'Starke Stürme',
  customWeathercomThunderstorms: 'Gewitter',
  customWeathercomRainSnow: 'Regen Schnee',
  customWeathercomRainSleet: 'Regen Schneeregen',
  customWeathercomWintryMix: 'Winterliche Mischung',
  customWeathercomFreezingDrizzle: 'Gefrierender Nieselregen',
  customWeathercomDrizzle: 'Nieselregen',
  customWeathercomFreezingRain: 'Gefrierender Regen',
  customWeathercomShowers: 'Duschen',
  customWeathercomRain: 'Regen',
  customWeathercomFlurries: 'Wirbelstürme',
  customWeathercomSnowShowers: 'Schneeschauer',
  customWeathercomBlowingDriftingSnow: 'Verwehter Schnee',
  customWeathercomSnow: 'Schnee',
  customWeathercomHail: 'Ave',
  customWeathercomSleet: 'Schneeregen',
  customWeathercomBlowingDustSandstorm: 'Blowing Dust Sandsturm',
  customWeathercomFoggy: 'Neblig',
  customWeathercomHaze: 'Dunst',
  customWeathercomSmoke: 'Rauch',
  customWeathercomBreezy: 'Breezy',
  customWeathercomWindy: 'Windig',
  customWeathercomFrigidIceCrystals: 'Frigide Eiskristalle',
  customWeathercomCloudy: 'Bewölkt',
  customWeathercomMostlyCloudy: 'Meist bewölkt',
  customWeathercomPartlyCloudy: 'Teilweise bewölkt',
  customWeathercomClear: 'Klar',
  customWeathercomSunny: 'Sonnig',
  customWeathercomFairMostlyClear: 'Ziemlich klar Meistens klar',
  customWeathercomFairMostlySunny: 'Schön Meist sonnig',
  customWeathercomMixedRainandHail: 'Gemischter Regen und Hagel',
  customWeathercomHot: 'Heiß',
  customWeathercomIsolatedThunderstorms: 'Vereinzelte Gewitter',
  customWeathercomScatteredThunderstorms: 'Vereinzelte Gewitter',
  customWeathercomScatteredShowers: 'Vereinzelte Schauer',
  customWeathercomHeavyRain: 'Starkregen',
  customWeathercomScatteredSnowShowers: 'Vereinzelte Schneeschauer',
  customWeathercomHeavySnow: 'Schwerer Schnee',
  customWeathercomBlizzard: 'Blizzard',
  customWeathercomNotAvailable: 'Nicht verfügbar',

  customSharedMountPointSetting: 'Mount Point Einstellung',
  customSharedMountPointSettingTitle:
    'Legen Sie den Montagepunkt der RTK-Referenzstation fest, der innerhalb der Organisation gemeinsam genutzt werden soll.',
  customSharedMountPoint: 'gemeinsamer Einhängepunkt',
  customMountPoint: 'Einhängepunkt',
  customStatus: 'Status',
  customNotSet: 'Nicht eingestellt.',
  customSelectMountPoint: 'Einhängepunkt wählen',
  customUnsharedMountPoint: 'Ungeteilt',
  customSelectMountPointTitle: 'Wählen Sie den Einhängepunkt für die Freigabe',
  customSharedMountPointRemarks1:
    'Montagepunkte werden ausgegeben, wenn AgriBus-GMiniR mit der Anwendung AgriBus-GTools als Referenzstation eingestellt wird. Wenn Sie eine Referenzstation eines anderen Herstellers verwenden, bewerben Sie sich bitte über den unten stehenden Link.',
  customSharedMountPointRemarks2: 'Klicken Sie hier, um sich zu bewerben.',
  customOnline: 'online',
  customOffline: 'off-line',
  customNotIssued: 'nicht ausgestellt',
  customSetItUp: 'Wir sind bereit.',
  customDeActivated: 'Deaktiviert.',
  customType: 'Klassifizierung',
  customCropIsNotRegistered: 'Der Bestand ist nicht registriert.',
  customNameNotRegistered: 'Name Unregistriert',

  customGoToPayerManager: 'Öffnen Sie die Administrationsseite',
  customPaymentInfo: 'Zahlungsinformationen',
  customProjectInfo: 'Projektinformationen',
  customAddProject: 'Projekt hinzufügen',
  customAddProjectRemarks: 'Bitte geben Sie den Projektnamen und die E-Mail-Adresse des Administrators an',
  customProjectName: 'Projektname',
  customProjectAdminMailAddress: 'Administrator E-Mail',
  customStop: 'Aufhängung',
  customStopDialogText: 'Möchten Sie das ausgewählte Projekt löschen?',
  customDone: 'Es ist vollbracht.',
  customUpdateDay: 'Update-Datum',
  customAdminName: 'Name des Managers',
  customMaxQuantity: 'maximale Anzahl von Personen',
  customaddProjectSuccess: 'Ihr Projekt wurde hinzugefügt.',
  customPlantingShowPast: 'Vergangene Bepflanzungen anzeigen',
  customPlantingHidePast: 'Vergangene Bepflanzungen ausblenden',
  customPlantingCropDisplayName: 'Name der Pflanzenanzeige',
  customPlantingCropVarietyName: 'Sortenname',
  customPlantingSeason: 'Anbausaison',
  customPlantingSeasonStartDate: 'Startdatum (erforderlich)',
  customPlantingSeasonEndDate: 'Enddatum',
  customPlantingAddCropOption: 'Ernteoption hinzufügen',
  customPlantingRemoveCropOption: 'Ernteoption entfernen',
  customPlantingCropSelectionRequiredError:
    'Sie müssen diese Option auswählen. Falls keine zutreffen, wählen Sie bitte "Sonstige".',
  customPlantingOtherCropSelectionRequiredError: 'Muss eingegeben werden, wenn Sie "Other" ausgewählt haben',
  customPlantingDeleteConfirmationMessage:
    "Sind Sie sicher, dass Sie {plantingName} löschen möchten? (alle zugehörigen Daten werden ebenfalls gelöscht)'",
  customPlantingFieldSelectionHint: 'Wenn der Feldname nicht gesetzt ist, erscheint er hier nicht in der Liste',

  customTaskDeleteMessage: 'Sind Sie sicher, dass Sie das ausgewählte Werk löschen möchten?',
  customTaskDeleteFailure: 'Das ausgewählte Werk konnte nicht gelöscht werden',
  customTaskDeleteSucceed: 'Sie haben das ausgewählte Werk erfolgreich gelöscht',

  customErrorStartDateRequired: 'Startdatum ist erforderlich',
  customErrorFieldRequired: 'Grundstücke sind unerlässlich',

  customAlreadyExistingUser:
    'Sie haben sich bereits mit Ihrer E-Mail-Adresse registriert. Bitte verwenden Sie eine nicht registrierte E-Mail-Adresse.',

  customNowProgressRateTitle: 'Fortschritt der Arbeiten',
  customNowProgressRateNotField: 'Keine relevanten Parzellen',

  customStandardSubscribeErrorMessage:
    'Der Kauf Ihres Abonnements ist fehlgeschlagen. Bitte überprüfen Sie die von Ihnen eingegebenen Informationen noch einmal.',
  customStripeCouponText1: 'Klicken Sie hier, um Ihren Gutschein einzulösen',
  customStripeCouponText2: 'Klicken Sie hier für den Gutscheincode',

  customUpdatePolygonFailure: 'Ich habe es versäumt, meine Parzellen zu aktualisieren.',

  customMultiPolygonImportError:
    'Daten mit MultiPolygonen, die in Polygone umgewandelt werden müssen, da MultiPolygone nicht unterstützt werden.',

  customSimpleSignUpAndSignInError: 'Es gibt ein Problem mit Ihrer E-Mail-Adresse oder Ihrem Passwort. Bitte prüfen.',
  customNewPasswordValidationError: 'Es sind mindestens ein Kleinbuchstabe und eine Zahl erforderlich.',

  // 2022.12.08
  customSelectPlanSelectPaymentMethodText: 'Wählen Sie eine Zahlungsmethode',
  customCardInfoHasNotBeenEnteredError: 'Bitte geben Sie Ihre Kartendaten ein',
  customNoPaymentMethodSeletedError: 'Keine Zahlungsmethode ausgewählt.',
  customFreeDashBoardText1: 'Für die Anmeldung bei AgriBus-Web ist ein Abonnement des kostenpflichtigen Plans (AgriBus Professional) erforderlich.',
  customFreeDashBoardText2: 'Für weitere Informationen siehe.',
  customFreeDashBoardText3: 'Hinweis',
  customFreeDashBoardText4: '.',
  customContractPlanTitle: 'Vertragsplan',
  customComparePlansText: 'Pläne vergleichen',
  customUpgradeToPlusText: 'Upgrade auf Plus',
  customDowngradeToPlusText: 'Herabstufung auf Plus.',
  customUpgradeToProfessionalText: 'Upgrade auf AgriBus Professional',
  customBillingBillingText1: 'Gekündigt - wird automatisch in einen kostenlosen Tarif umgewandelt, wenn er abläuft.',
  customUpgradeConfirematoinText: 'Ich werde auf AgriBus Professional upgraden. Ist das für Sie in Ordnung?',
  customDowngradeConfiremationText: 'Wir werden auf Plus zurückgestuft. Darf ich?',
  customBankTransfer: 'Banküberweisung',
  customHome: 'Startseite',
  customBillingMessageSubscribeGoogle:
    'Sie haben derzeit den Google Play Store abonniert; bitte aktualisieren/downgraden Sie Ihr Abonnement im Google Play Store',
  customInvoiceReceiptAddresseeTitle: 'Adresse der Rechnung/Quittung',
  customChangeAddresseeBtnText: 'Ändern Sie die Adresse.',
  customBillingEmailAddressTitle: 'E-Mail Adresse für die Rechnungsstellung',
  customChangeBillingEmailAddressText: 'Ändern Sie Ihre Rechnungs-E-Mail-Adresse',
  customCannotDowngradeText: 'Banküberweisungen können nicht auf Plus herabgestuft werden.',
  customChangePaymentMethodsToCard: 'Wechsel zur Kartenzahlung',
  customChangePaymentMethodsToCustomerBalance: 'Wechsel zur Banküberweisung',
  customChangePaymentMethodToSendInvoiceText: 'Kann ich meine Zahlungsmethode auf Banküberweisung ändern?',
  customMapGaugeDescriptionColorCodedFill:
    'Wurde die App farblich gestaltet, wird ein farblich gekennzeichneter Arbeitsverlauf angezeigt.',
  customColorCodeFill: 'Füllen nach Farbe',
  customSelectDefaultIconTitle: 'Bitte wählen Sie ein Symbol',
  customImportLimitMessage: 'Die maximale Anzahl von Importen ist {limit}.',
  customPresetIcon: {
    title: 'Voreinstellung',
    description: 'Wählen Sie aus sechs verschiedenen Voreinstellungen.',
    btnText: 'Auswahl aus Voreinstellungen',
  },
  customBulkDeleteCheckboxText: 'Massenlöschung',
  customBulkDeleteDialogText: 'Kann ich eine Massenlöschung durchführen?',
  customPerimeter: 'Perimeter',
  feed: {
    menu: 'Feed',
    title: 'News-Feed',
    description: 'Tägliche regionale Statistik der Feldarbeit (anonymisiert) und Neuigkeiten aus den Anbauregionen.',
    yourArea: 'Aktivität in Ihrer Region (~33 km)',
    areaFromFields: 'Aus Ihren Feldern ermittelt',
    widerArea: 'Größeres Umfeld (~55 km)',
    national: 'Landesweite Aktivität',
    daily: 'Gestern',
    weekly: 'Letzte 7 Tage',
    monthly: 'Letzte 28 Tage',
    vsNormal: 'ggü. Normal',
    vsLastYear: 'ggü. Vorjahr',
    noData: 'Zu wenig Daten in dieser Region (zu wenige Arbeiten in der Nähe).',
    noAreaHint: 'Registrieren Sie Ihre Felder, um Statistiken für Ihre Region zu sehen.',
    nationalFallback: 'Unten sehen Sie die landesweite Statistik.',
    upsell: 'Bezahlpläne bieten zusätzlich Tages- und 28-Tage-Fenster sowie die ~55-km-Ansicht.',
    monitorTitle: 'Wöchentlicher Monitorbericht',
    monitorActive: 'Beobachtungsmuster aktiv',
    monitorNone: 'Kein Beobachtungsmuster',
    toMarketInsights: 'Market Insights öffnen',
    loadError: 'Feed konnte nicht geladen werden. Bitte später erneut versuchen.',
    disclaimer: 'Die regionale Aktivität ist eine anonymisierte Statistik, keine Bewertung einzelner Betriebe.',
    kindNews: 'Neuigkeiten',
    kindPr: 'PR',
    readMore: 'Mehr erfahren',
    entryDaily: 'Arbeitsaktivität am {date}',
    entryWeekly: 'Wochenübersicht (bis {date})',
    areaC3: 'Ihre Region',
    areaC5: 'Weitere Umgebung',
    areaJp: 'Landesweit',
    historyTitle: 'Bisheriger Verlauf',
    kindSignal: 'Signal',
    shareTitle: 'Im Feed teilen',
    share: 'Teilen',
    shareVisibility: 'Sichtbarkeit',
    visFollowers: 'Nur Follower',
    visNeighborhood: 'Nachbarschaft',
    visPublic: 'Öffentlich',
    shareRoute: 'Arbeitsweg anzeigen',
    shareExact: 'Genauen Standort teilen (Kartenhintergrund)',
    statTime: 'Zeit',
    statDistance: 'Distanz',
    statArea: 'Fläche',
    statWidth: 'Breite',
    statSpeed: 'Tempo',
    statGnss: 'GNSS',
    shareComment: 'Kommentar',
    shareSubmit: 'Teilen',
    sharePosted: 'Geteilt',
    shareFailed: 'Aktion fehlgeschlagen. Bitte später erneut versuchen.',
    consentNote: 'Ihr Beitrag wird Nutzern im gewählten Sichtbarkeitsbereich angezeigt. Der Standort wird nur als ungefähre Region (ca. 11 km) angezeigt.',
    consentLabel: 'Ich stimme den Teilen-Bedingungen (Art. 15-2) zu',
    postDelete: 'Löschen',
    postDeleted: 'Beitrag gelöscht',
    postDeleteConfirm: 'Diesen Beitrag löschen?',
    report: 'Melden',
    reportTitle: 'Beitrag melden',
    reportConfirm: 'Diesen Beitrag dem Betreiber melden?',
    reportReason: 'Grund (optional)',
    reportDone: 'Meldung gesendet. Vielen Dank',
    visPrivate: 'Nur ich',
    followRequested: 'Angefragt',
    followAccept: 'Annehmen',
    followDecline: 'Ablehnen',
    followAccepted: 'Folgeanfrage angenommen',
    unfollow: 'Entfolgen',
    unfollowConfirm: 'Diesem Nutzer entfolgen?',
    connectionsHint: 'Folgeanfragen können aus Feed-Beiträgen gesendet werden. Nach Annahme sind Beiträge nur für Follower sichtbar',
    sharePhotos: 'Fotos hinzufügen (max. 4)',
    sharePhotosHint: 'Standortdaten (EXIF) werden automatisch entfernt',
    snsShare: 'Teilen',
    copyLink: 'Link kopieren',
    linkCopied: 'Link kopiert',
    shareOther: 'Andere Apps',
    instagramSaved: 'Kartenbild gespeichert. Bitte ueber die Instagram-App posten',
    manualRecords: 'Manuelle Einträge',
    addManualRecord: 'Manuellen Eintrag hinzufügen',
    manualChip: 'Manuell',
    recordStart: 'Startzeit',
    recordEnd: 'Endzeit',
    recordMemo: 'Notiz',
    recordDuration: 'Dauer (Min.)',
    recordCreated: 'Eintrag hinzugefuegt',
    recordDeleteConfirm: 'Diesen Eintrag löschen?',
    noManualRecords: 'Noch keine manuellen Einträge',
    poiRecords: 'Orte (POI)',
    addPoi: 'Ort hinzufügen',
    poiTitle: 'Titel',
    poiMapHint: 'Klicken Sie auf die Karte, um den Ort festzulegen. Andernfalls werden Fotodaten verwendet',
    noPoiRecords: 'Noch keine Orte',
    map: 'Karte',
    mapLayers: 'Ebenen',
    editMode: 'Bearbeitungsmodus',
    selected: 'Ausgewählt',
    mergeSave: 'Zusammengeführt speichern',
    clipDraw: 'Zuschnittbereich zeichnen',
    saveAsField: 'Anbaufläche als Feld speichern',
    workWidthM: 'Arbeitsbreite (m)',
    workName: 'Name',
    workSaved: 'Abgeleiteter Datensatz gespeichert',
    derivedRecords: 'Abgeleitete Datensätze',
    derivedChip: 'Abgeleitet',
    derivedDeleteConfirm: 'Diesen abgeleiteten Datensatz löschen?',
    saveRangeAsWork: 'Ausgewählten Bereich als abgeleiteten Datensatz speichern',
    clipByField: 'Nach Feld zuschneiden',
    showOnMap: 'Auf der Karte anzeigen',
    editRange: 'Bereich bearbeiten',
    trajectoryChip: 'GPS',
    derivedRecordsDescription: 'Arbeitsdatensätze 1:1 zu jeder Fahrspur. Bearbeitete und manuelle Datensätze erscheinen ebenfalls hier',
    spatialEdit: 'Zuschneiden / Feld speichern',
    vraTitle: 'VRA-Karte',
    vraDescription: 'Zonenkarten für teilflächenspezifische Ausbringung aus Satelliten-Vegetationsindizes erzeugen',
    vraGenerate: 'Neue Karte erzeugen',
    vraIndex: 'Vegetationsindex',
    vraGridSize: 'Raster (m)',
    vraDirection: 'Richtung (Grad)',
    vraCloudPct: 'Max. Wolken (%)',
    vraImages: 'Verwendete Bilder',
    vraFailed: 'Erzeugung fehlgeschlagen. Möglicherweise keine wolkenfreien Bilder im Zeitraum',
    saveFailed: 'Speichern fehlgeschlagen',
    mapSetGenerated: 'Generierung abgeschlossen',
    fieldValidFromDate: 'Gültig ab: {date}',
    fieldDeleteLinked: '{fieldName} kann nicht gelöscht werden, da es mit folgenden Daten verknüpft ist.',
    fieldDeleteLinkedTasks: 'Arbeitsaufzeichnungen: {count}',
    fieldDeleteLinkedSets: 'Feldgruppen: {names}',
    fieldDeleteLinkedHint: 'Entfernen Sie zuerst die verknüpften Arbeitsaufzeichnungen und Feldgruppen.',
    elevSource: 'Quelle',
    elevSourceDem: 'Satellit (DEM)',
    elevSourceGnss: 'Arbeitshistorie (GNSS)',
    elevCenter: 'Farbzentrum',
    elevCenterMean: 'Mittelwert',
    elevCenterMedian: 'Median',
    elevCenterValue: 'Zentrumshöhe',
    elevCustom: 'Benutzerdefiniert',
    elevRange: 'Farbbereich',
    elevRangeWidth: 'Bereichsbreite',
    elevContour: 'Höhenlinien',
    zoneBands: 'Stufen',
    zonePalette: 'Color scheme',
    paletteHue: 'HSI (green→yellow→red)',
    paletteYlgn: 'Yellow→Green',
    paletteGnrd: 'Green→Red',
    reclassifyTitle: 'Stufen/Farben ändern (ohne Neuerzeugung)',
    reclassifyApply: 'Neu klassifizieren',
    followByEmail: 'Folgeanfrage per E-Mail-Adresse',
    emailUserNotFound: 'Kein Benutzer mit dieser E-Mail-Adresse gefunden',
    followRequestSent: 'Folgeanfrage gesendet',
    eventSettingsTitle: 'Feed settings (auto events)',
    eventSettingsVisibility: 'Event visibility',
    eventSettingsLocation: 'Location visibility',
    eventSettingsSnsStrip: 'Strip exact location when sharing to SNS (default)',
    eventSettingsPrefs: 'Events posted to your feed',
    locHidden: 'Hidden',
    locApprox: 'Approximate (~10 km grid)',
    locExact: 'Include exact location',
    event_work_start: 'Work started',
    event_work_end: 'Work finished',
    event_field_enter: 'Entered field',
    event_field_exit: 'Left field',
    event_poi_added: 'POI added',
    event_vra_map_added: 'VRA map added',
    event_elevation_map_added: 'Height map added',
    event_refline_added: 'Guidance line added',
    event_field_added: 'Field added',
    event_field_set_added: 'Field set added',
    event_work_start_text: 'started working ({name})',
    event_work_end_text: 'finished working ({name})',
    event_field_enter_text: 'entered field \u201c{name}\u201d',
    event_field_exit_text: 'left field \u201c{name}\u201d',
    event_poi_added_text: 'added POI \u201c{name}\u201d',
    event_vra_map_added_text: 'created VRA map \u201c{name}\u201d',
    event_elevation_map_added_text: 'created height map \u201c{name}\u201d',
    event_refline_added_text: 'added guidance lines ({name})',
    event_field_added_text: 'added field \u201c{name}\u201d',
    event_field_set_added_text: 'created field set \u201c{name}\u201d',
    vraNameAuto: 'Name (leer = automatisch)',
    eventPrefOff: 'Do not post',
    visEditTitle: 'Change visibility',
    visEditLocationExact: 'Show exact location (map background)',
    visEditRemoveLocation: 'Remove exact location',
    visEditPublicNote: 'Exact location is automatically excluded for public posts',
    consentRequiredToShare: 'Sharing requires consent to the sharing terms. Enable sharing from a regular post first',
    elevGnssFailed: 'Höhenberechnung fehlgeschlagen. Keine passende Arbeitshistorie (GNSS-Höhen) gefunden oder noch in Bearbeitung. Lockern Sie den GNSS-Filter oder den Datumsbereich',
    elevDescription: 'Höhenkarten aus GNSS-Höhen der Arbeitshistorie erzeugen (RTK empfohlen). Ohne Arbeitshistorie sind Satelliten-Höhendaten (DEM) verfügbar. Synchronisiert wie VRA-Karten mit NAVI',
    fieldValidUntil: 'Gültig bis: {date}',
    mapSetGeneratedWithCount: '{created} erstellt / {failed} fehlgeschlagen (vorhandene Karten derselben Felder werden ersetzt)',
    vraGenerating: 'Satellitenbilder werden analysiert...',
    vraObsDate: 'Beobachtungsdatum',
    vraPeriodMean: 'Zeitraum-Mittel',
    vraLimitReached: 'Erzeugungslimit erreicht (Free: 3 insgesamt, Bezahltarife: 10 pro Tag)',
    vraExport: 'ISOXML exportieren',
    vraModeGrid: 'Raster (Grid)',
    vraModePolygon: 'Polygon',
    vraRate: 'Ausbringmenge (kg/ha)',
    vraCellSize: 'Zellengröße (m)',
    vraEditMap: 'Bearbeiten',
    mapSets: 'Feldgruppen',
    mapSetDescription: 'Felder per Filter (Gültigkeitszeitraum, Kultur, Name) gruppieren. U. a. für die VRA-Kartenerstellung',
    mapSetCreate: 'Feldgruppe erstellen',
    fieldSetEmpty: 'Noch keine Feldgruppen',
    mapSetTargetDate: 'Stichtag',
    mapSetCrop: 'Kultur',
    mapSetNameContains: 'Feldname (enthält)',
    mapSetMemoContains: 'Memo (enthält)',
    mapSetPreviewCount: 'Passende Felder',
    mapSetGenerate: 'Erzeugen/Aktualisieren',
    mapSetFields: 'Felder',
    mapSetLastGenerated: 'Zuletzt erzeugt',
    fieldAttrsTitle: 'Feldattribute (Gültigkeit & Kultur)',
    fieldValidFrom: 'Gültig ab (leer = unbegrenzt)',
    fieldValidTo: 'Gültig bis (leer = unbegrenzt)',
    mapSetNoMatch: 'Keine Felder entsprechen dem Filter',
    mapSetDeleteConfirm: 'Diesen Feldsatz und die daraus erzeugten VRA-Karten löschen?',
    trajectories: 'Aufgezeichnete Fahrten',
  },
  marketInsights: {
    menu: 'Marktinformationen',
    title: 'Marktinformationen (AgriBus-DWH)',
    description: 'Sehen Sie täglich den Arbeitsfortschritt und Marktbeobachtungen der wichtigsten Soja- und Weizenanbaugebiete der Welt. Ein Mitgliedsvorteil: Ihre Arbeitsdaten (anonyme Statistik) kommen als nützliche Information zu Ihnen zurück, z. B. für den Verkaufszeitpunkt.',
    soybeanDescription: 'Erntelage und Marktsignale der Soja-Anbaugebiete in Brasilien und den USA',
    wheatDescription: 'Erntelage und Marktsignale der Weizen-Anbaugebiete',
    open: 'Öffnen',
    upsell: 'Marktinformationen sind ein Vorteil für Mitglieder mit kostenpflichtigem Plan. Mit einem kostenpflichtigen Plan können Sie sie ohne Zusatzkosten ansehen.',
    memberNote: 'Beim Betrachten als Mitglied wird oben links im Monitor ein Abzeichen angezeigt. Diese Informationen sind keine Anlageempfehlung.',
  },
}
